export let ConsentPolicyCategories = /*#__PURE__*/function (ConsentPolicyCategories) {
  ConsentPolicyCategories["Functional"] = "functional";
  ConsentPolicyCategories["Analytics"] = "analytics";
  return ConsentPolicyCategories;
}({});
//# sourceMappingURL=types.js.map